// @flow
import * as React from 'react';

import { useEffect } from 'react';

import clsx from 'clsx';

import { BurgerButton } from '@gandi/ui/layout';

import { HeaderMenuContext } from '../LandingPagesControls/HeaderMenuContext';

import PreferencesWidget from '../PreferencesWidget/PreferencesWidget';
import type { DialogState } from '../PreferencesWidget/types';

import UserWidget from '../UserWidget/UserWidget';

import styles from './LandingPagesWidgets.scss';

type Props = {
  preferencesDialog: DialogState,
  /** The Cart widget */
  widgets: React.Node,
};

// Show in the shopping pages
export function LandingPagesWidgets({
  preferencesDialog,
  widgets,
}: Props): React.MixedElement {
  const { mainMenuOpen, setMainMenuOpen, burgerRef } =
    React.useContext(HeaderMenuContext);

  // Toggle mobile overlay
  const toggleBurger = () => {
    setMainMenuOpen(prev => {
      if (prev && burgerRef.current) {
        requestAnimationFrame(() => {
          burgerRef.current?.focus();
        });
      }
      return !prev;
    });
  };

  // Close overlay when clicking a link inside it; close on Escape
  useEffect(() => {
    function onDocClick(event: Event): void {
      const t = event.target instanceof Element ? event.target : null;
      const interactiveInOverlay = t?.closest('#mainmenu a');
      if (interactiveInOverlay) {
        setMainMenuOpen(false);
      }
    }

    function onEsc(e: KeyboardEvent): void {
      if (e.key === 'Escape') {
        setMainMenuOpen(false);
        requestAnimationFrame(() => {
          if (burgerRef.current) {
            burgerRef.current.focus();
          }
        });
      }
    }

    document.addEventListener('click', onDocClick, true);
    document.addEventListener('keydown', onEsc, true);
    return () => {
      document.removeEventListener('click', onDocClick, true);
      document.removeEventListener('keydown', onEsc, true);
    };
  }, [setMainMenuOpen, burgerRef]);

  return (
    <div className={styles.root}>
      <div className={clsx(mainMenuOpen && styles.hideOnMobile)}>
        <PreferencesWidget dialog={preferencesDialog} />
      </div>
      <div className={styles.userWidget}>
        <UserWidget />
      </div>
      {/* cart */}
      <div className={clsx(mainMenuOpen && styles.hideOnMobile)}>{widgets}</div>
      <div className={clsx(styles.BurgerButtonCtn)}>
        <BurgerButton
          open={mainMenuOpen}
          onToggle={toggleBurger}
          innerRef={burgerRef}
        />
      </div>
    </div>
  );
}
